import React from "react";
import { Link } from "react-router-dom";
import Shared from "../../../components/ReUseAbleComponents/Shared";

function HelpCenter(props) {
  return (
    <>
      <Shared />
      <div className="dx-box-5 bg-grey-6">
        <div className="container">
          <div className="row justify-content-center vertical-gap">
            <div className="col-12 col-md-4 col-lg-3 dx-feature-variable">
              <div className="dx-feature dx-feature-3 dx-feature-color-1 dx-block-decorated">
                <div className="dx-feature-icon">
                  <span className="icon pe-7s-copy-file"></span>
                </div>
                <div className="dx-feature-cont">
                  <div className="dx-feature-title">
                    <Link to="/documentations">DocumentationLink</Link>
                  </div>
                  <div className="dx-feature-text">
                    Phasellus interdum est diam, eu varius odio tincidunt eget
                    ultrices et
                  </div>
                  <Link
                    to="/documentations"
                    className="dx-btn dx-btn-link d-flex dx-feature-link"
                  >
                    Read More <span className="icon pe-7s-angle-right"></span>
                    Link
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 col-lg-3 dx-feature-variable">
              <div className="dx-feature dx-feature-3 dx-feature-color-2 dx-block-decorated">
                <div className="dx-feature-icon">
                  <span className="icon pe-7s-notebook"></span>
                </div>
                <div className="dx-feature-cont">
                  <div className="dx-feature-title">
                    <Link to="/articles">Knowledge BasLink</Link>
                  </div>
                  <div className="dx-feature-text">
                    Aliquam id nisi sit amet massa mollis lobortis interdum
                    felis integer at arcu mattis
                  </div>
                  <Link
                    to="/articles"
                    className="dx-btn dx-btn-link d-flex dx-feature-link"
                  >
                    Read More <span className="icon pe-7s-angle-right"></span>
                    Link
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 col-lg-3 dx-feature-variable">
              <div className="dx-feature dx-feature-3 dx-feature-color-3 dx-block-decorated">
                <div className="dx-feature-icon">
                  <span className="icon pe-7s-chat"></span>
                </div>
                <div className="dx-feature-cont">
                  <div className="dx-feature-title">
                    <Link to="/forum">ForumLink</Link>
                  </div>
                  <div className="dx-feature-text">
                    Sed eget nibh justo euismod maximus et vel nisl pellentesque
                    suscipit nisi
                  </div>
                  <Link
                    to="/forum"
                    className="dx-btn dx-btn-link d-flex dx-feature-link"
                  >
                    Read More <span className="icon pe-7s-angle-right"></span>
                    Link
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 col-lg-3 dx-feature-variable">
              <div className="dx-feature dx-feature-3 dx-feature-color-4 dx-block-decorated">
                <div className="dx-feature-icon">
                  <span className="icon pe-7s-ticket"></span>
                </div>
                <div className="dx-feature-cont">
                  <div className="dx-feature-title">
                    <Link to="/ticket">Ticket SysteLink</Link>
                  </div>
                  <div className="dx-feature-text">
                    Vivamus sceleriue libero velit blandit, hendrerit nisl
                    at,dapibus sollicitudin
                  </div>
                  <Link
                    to="/ticket"
                    className="dx-btn dx-btn-link d-flex dx-feature-link"
                  >
                    Read More <span className="icon pe-7s-angle-right"></span>
                    Link
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="dx-separator"></div>
      <div className="dx-box-5 pb-100">
        <div className="container mt-4 mnb-7">
          <div className="row align-items-center vertical-gap mnt-30 sm-gap mb-50">
            <h2 className="col-auto h4 mb-0 mt-0">Popular Articles</h2>
            <div className="col pl-30 pr-30 d-none d-sm-block">
              <div className="dx-separator"></div>
            </div>
            <div className="col-auto dx-slider-arrows-clone"></div>
          </div>

          <div
            className="swiper-container dx-slider dx-slider-arrows dx-slider-articles"
            data-swiper-speed="400"
            data-swiper-space="50"
            data-swiper-slides="3"
            data-swiper-breakpoints="true"
            data-swiper-arrows="true"
            data-swiper-arrows-clone="true"
            data-swiper-loop="true"
            data-swiper-autoHeight="true"
            data-swiper-grabCursor="true"
          >
            <div className="swiper-wrapper">
              <div className="swiper-slide">
                <div className="dx-article dx-article-list">
                  <h4 className="h6 mt-0">Quantial</h4>
                  <ul className="dx-list">
                    <li>
                      <Link to="/single-article">
                        Make menu dropdown working without JavaScript Link
                      </Link>
                    </li>
                    <li>
                      <Link to="/single-article">Google AnalyticLink</Link>
                    </li>
                    <li>
                      <Link to="/single-article">
                        How to manually import Demo data (if you faced with
                        problems in one-click demo import) Link
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="swiper-slide">
                <div className="dx-article dx-article-list">
                  <h4 className="h6 mt-0">Sensific</h4>
                  <ul className="dx-list">
                    <li>
                      <Link to="/single-article">WordPress Themes FALink</Link>
                    </li>
                    <li>
                      <Link to="/single-article">
                        Change navbar background coloLink
                      </Link>
                    </li>
                    <li>
                      <Link to="/single-article">
                        Change images and banners overlay color Link
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="swiper-slide">
                <div className="dx-article dx-article-list">
                  <h4 className="h6 mt-0">Minist</h4>
                  <ul className="dx-list">
                    <li>
                      <Link to="/single-article">
                        Add top menu link inside dropdown on mobile devices Link
                      </Link>
                    </li>
                    <li>
                      <Link to="/single-article">
                        Google Map API Warning (NoApiKeys) Link
                      </Link>
                    </li>
                    <li>
                      <Link to="/single-article">
                        Make dropdown items links working Link
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="swiper-button-prev">
              <span className="icon pe-7s-angle-left"></span>
            </div>
            <div className="swiper-button-next">
              <span className="icon pe-7s-angle-right"></span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default HelpCenter;
